import React from 'react';

const EllipseLeft = () => {
  return (
    <svg 
      width="648" 
      height="2688" 
      viewBox="0 0 648 2688" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto max-w-none"
    >
      <path 
        d="M-24.5311 185.526C-666.253 -184.973 -1515.62 17.4327 -1885.63 658.316C-2255.65 1299.2 -2006.25 2135.98 -1364.53 2506.47C-722.837 2876.96 97.3268 2657.73 467.357 2016.82C837.387 1375.91 617.163 556.008 -24.5311 185.526Z" 
        stroke="url(#paint0_linear_12282_14547)" 
        strokeWidth="2"
      />
      <defs>
        <linearGradient id="paint0_linear_12282_14547" x1="25.5" y1="362.976" x2="-334.5" y2="2610.48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBF8F4" stopOpacity="0.1"/>
          <stop offset="0.206731" stopColor="#D6CFF8"/>
          <stop offset="1" stopColor="#899B30"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EllipseLeft;